require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-100-students-learning-the-foundations-of-computer-science.json") })
        }
      }, "path---blog-100-students-learning-the-foundations-of-computer-science");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-100-students-learning-the-foundations-of-computer-science!./.cache/json/blog-100-students-learning-the-foundations-of-computer-science.json
// module id = 547
// module chunks = 231608221292675